var KR_I18n = KR_I18n || {};

KR_I18n["es-PE"] = {"amount":"Monto","qr_code_label":"Escanee y pague con [METHOD]"};

if ((typeof(module) !== "undefined") && (typeof(module.exports) !== "undefined")) module.exports = KR_I18n["es-PE"];

